/**
 * Simple S3 Configuration utilities
 */
export const S3Config = {
    // Only use CDN URL as other methods don't have permissions
    CDN_URL: import.meta.env.VITE_AWS_CDN_URL || '',
    CDN_URL_UPLOAD: import.meta.env.VITE_AWS_CDN_URL_UPLOADS_PREFIX || '',

    // Get full URL for cache key using only CDN
    getFullUrl: (key: string): string => {
        const cdnUrl = S3Config.CDN_URL;

        if (!cdnUrl) {
            throw new Error('CDN URL not configured. Set VITE_AWS_CDN_URL in environment variables.');
        }

        return `${cdnUrl}/${key}`;
    },
    isS3UploadUrl: (url: string): boolean => {
        return url.includes(S3Config.CDN_URL);
    },
    getS3UploadUrl: (fileKey: string): string | undefined => {
        if (!S3Config.CDN_URL || !S3Config.CDN_URL_UPLOAD) {
            return undefined;
        }
        return `${S3Config.CDN_URL}/${S3Config.CDN_URL_UPLOAD}/${fileKey}`;
    },
};

export const { getFullUrl, isS3UploadUrl, getS3UploadUrl } = S3Config;
